import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, tap } from 'rxjs/operators';

import * as booksActions from './books.actions';

import { Router } from '@angular/router';
import { RoutesService } from '../../shared/services/routes.service';
import { BooksService } from '../../shared/services/books.service';


@Injectable()
export class BooksEffects {

    constructor(
        private itemsService: BooksService,
        private actions$: Actions,
        private router: Router,
        private routesService: RoutesService
    ) { }

    @Effect()
    DoGetInfoBooks$: Observable<Action> = this.actions$.pipe(
        ofType(booksActions.DO_GET_INFO_BOOKS),
        switchMap((action: booksActions.DoGetInfoBooks) => {
            return this.itemsService.get(action).pipe(
                map( response => {
                    response.list = this.itemsService.transformListFromApi(response.list);
                    return new booksActions.DoGetInfoBooksOK(response);
                }),
                catchError(error => of(new booksActions.DoGetInfoBooksKO(error)))
            );
        }));

    @Effect()
    DoGetInfoBooksFilters$: Observable<Action> = this.actions$.pipe(
        ofType(booksActions.DO_GET_INFO_FILTERS),
        switchMap((action: booksActions.DoGetInfoBooksFilters) => {
            return this.itemsService.getFilters().pipe(
                map( response => new booksActions.DoGetInfoBooksFiltersOK(response)),
                catchError(error => of(new booksActions.DoGetInfoBooksFiltersKO(error)))
            );
        }));


    @Effect()
    DoSetSelectedFilters$: Observable<Action> = this.actions$.pipe(
        ofType(booksActions.DO_SET_SELECTED_FILTERS),
        switchMap((action: booksActions.DoSetSelectedFilters) => {
            return this.itemsService.get(action).pipe(
                map( response => {
                    response.list = this.itemsService.transformListFromApi(response.list);
                    return new booksActions.DoGetInfoBooksOK(response);
                }),
                catchError(error => of(new booksActions.DoGetInfoBooksKO(error)))
            );
        }));
}
